module.exports = __webpack_public_path__ + "img/icon-hide-group.1041726e.svg";